/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedDetail_detailValues$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespDetails_item$ref: FragmentReference;
export type PdpRespDetails_item = {|
  +pdpDetailsDisplay: ?$ReadOnlyArray<?{|
    +detailKey: ?string,
    +delimiter: ?string,
    +detailDisplayName: ?string,
    +detailValues: ?$ReadOnlyArray<?{|
      +$fragmentRefs: PdpSharedDetail_detailValues$ref
    |}>,
  |}>,
  +$refType: PdpRespDetails_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespDetails_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pdpDetailsDisplay",
      "storageKey": null,
      "args": null,
      "concreteType": "PdpDetail",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "detailKey",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "delimiter",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "detailDisplayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "detailValues",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedDetail_detailValues",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '92a50f701f428d844e92c835913678c6';
module.exports = node;
